import { convertDateStampFromUTC } from '../utils/timezone';

// Pure: depends only on its arguments, so it lives at module scope and keeps
// one identity for the life of the app. Memoized rows receive it as a prop
// (#1790); a per-render closure here would defeat every row's memo.
const formatDate = (utcDateStamp, format = 'date-only', options = {}) => {
  if (!utcDateStamp) return '-';

  // For date-only format, use the new noon-based conversion
  if (format === 'date-only' || format === 'date-short') {
    const localDateString = convertDateStampFromUTC(utcDateStamp);
    if (!localDateString) return '-';

    const [year, month, day] = localDateString.split('-');
    if (format === 'date-short') {
      return `${month}/${day}/${year.slice(-2)}`;
    }
    return `${month}/${day}/${year}`;
  }

  // For full format with time, convert to ISO string and format
  const utcISOString = utcDateStamp.includes('T') ? utcDateStamp : `${utcDateStamp}T00:00:00.000Z`;
  try {
    const date = new Date(utcISOString);
    if (isNaN(date.getTime())) return '-';

    if (format === 'full') {
      return date.toLocaleString(undefined, options);
    }

    return date.toLocaleDateString();
  } catch {
    return '-';
  }
};

/**
 * Hook for timezone-aware date formatting
 * Use this in components that need to format multiple dates
 */
export const useTimezoneAwareDateFormatting = () => ({ formatDate, isReady: true });
